<template>
  <div>
    <v-row class="grey darken-4 mx-0">
      <v-col cols="6" sm="4" md="3" lg="2" dense>
        <c-select
          :rotulo="$t('labels.opcoesBusca')"
          itemText="label"
          itemValue="value"
          :clearable="false"
          :lista="translatedOptions"
          :item.sync="searchFields.option"
          @input="changeValue"
        />
      </v-col>
      <v-col cols="6" md="3" lg="3">
        <v-text-field
          :label="$t('labels.termoBusca')"
          :placeholder="
            searchFields.option.value
              ? $t(`labels.${searchFields.option.value}`)
              : ''
          "
          class="text-caption"
          :type="searchFields.option.type ? searchFields.option.type : 'text'"
          outlined
          dense
          dark
          v-model="searchFields.text"
        />
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="3" dense>
        <div>
          <v-select
            v-model="searchFields.constructionStatus"
            item-value="text"
            :items="statusList"
            class="text-caption"
            :label="`Status ${$t('labels.obra')}`"
            :placeholder="
              $t(
                `placeholders.${
                  statusList && statusList.length > 0 ? 'autocomplete' : 'busca'
                }`,
                { campo: `Status ${$t('labels.obra')}` }
              )
            "
            persistent-hint
            outlined
            dense
            multiple
            clearable
            dark
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption">
                (+{{
                  `${searchFields.constructionStatus.length - 1} ${$t(
                    'labels.outros'
                  )}`
                }}
                )
              </span>
            </template>
          </v-select>
        </div>
      </v-col>
      <v-col md="4" lg="2" dense>
        <v-checkbox
          v-model="searchFields.useDate"
          class="customClass"
          dark
          dense
          :label="`Filtrar por ${$t('labels.data')}`"
        />
      </v-col>
      <v-col
        cols="4"
        md="3"
        lg="2"
        v-if="searchFields.useDate"
        style="width: 120px"
        dense
      >
        <div>
          <v-menu
            ref="menuDataIni"
            v-model="menuDataIni"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="200px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchFields.dataIni"
                prepend-icon="mdi-calendar"
                type="date"
                class="text-caption"
                style="width: 120px"
                :hint="$t('labels.dataInicial')"
                persistent-hint
                v-bind="attrs"
                v-on="on"
                dark
                dense
              />
            </template>
          </v-menu>
        </div>
        <div>
          <v-menu
            ref="menuDataFim"
            v-model="menuDataFim"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="200px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="searchFields.dataFim"
                prepend-icon="mdi-calendar"
                type="date"
                class="text-caption"
                style="width: 120px"
                :hint="$t('labels.dataFinal')"
                persistent-hint
                v-bind="attrs"
                v-on="on"
                dark
                dense
              />
            </template>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <c-index-buttons
      @search="sendSearch()"
      @register="openRegister()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :table-header="tableHeaderSelected"
          :table-items="constructionList"
          :loading="loadingItems"
          :doDelete="doDelete"
          selectable
          :estiloLinha="estiloLinha"
          @item-selected="selectItem($event)"
          route="obra.register"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          v-model="query.page"
          :total-visible="pagination.per_page"
          :length="pagination.last_page"
          :disabled="loadingItems"
          @input="sendSearch()"
        />
      </v-col>
    </v-row>

    <router-view />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>

<script>
import MegabitTable from '@/components/shared/table/MegabitTable'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cIndexButtons from '@/components/shared/base-buttons/IndexButtons'
import { getTodayDateTimeLocal, formatDateToTimestamps } from '@/utils/utils'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: { MegabitTable, cSelect, cIndexButtons },
  mixins: [tableMixin, headerMixin],
  data: () => ({
    estiloLinhaFaturada: 'green--text font-weight-bold',
    estiloLinhaObraAtrasada: 'red--text font-weight-bold',
    headerName: 'constructionIndex',
    menuDataIni: false,
    menuDataFim: false,
    options: [
      { label: 'Código', value: 'codigo', type: 'number' },
      { label: 'Nome Obra', value: 'obra' },
      { label: 'Empresa', value: 'empresa' },
      { label: 'Observação', value: 'observacao' },
    ],
    searchFields: {
      option: {},
      dataIni: new Date().toISOString().substr(0, 10),
      dataFim: new Date().toISOString().substr(0, 10),
      useDate: false,
    },
    query: {
      codigo: '',
      nome: '',
      obra: '',
      empresa: '',
      vendedor: '',
      observacao: '',
      status: [],
      dataInicial: '',
      dataFinal: '',
      page: 1,
    },
    tableHeaderAvaiable: [
      {
        label: 'codigo',
        text: 'Código',
        value: 'CODIGO',
        width: '50px',
        show: true,
      },
      {
        label: 'nome',
        text: 'Nome',
        value: 'NOME',
        align: 'start',
        show: true,
      },
      {
        text: 'Cód. Emp.',
        value: 'COD_EMP',
        align: 'start',
        width: 80,
        show: true,
      },
      {
        label: 'nomeempresa',
        text: 'Nome Empresa',
        value: 'NOME_EMP',
        align: 'start',
        show: true,
      },
      {
        label: 'razao',
        text: 'Razão Social',
        value: 'RAZAOSOCIAL',
        align: 'start',
        show: true,
      },
      { label: 'telefone', text: 'Fone', value: 'FONE', width: 80, show: true },
      { label: 'data', text: 'Data', value: 'DATA', width: 80, show: true },
      { text: 'Status', value: 'STATUS', show: true },
      {
        label: 'acoes',
        text: 'Ações',
        value: 'controls',
        align: 'right',
        sortable: false,
        show: true,
      },
    ],
  }),
  computed: {
    ...mapState('constructionModule', [
      'loadingItems',
      'pagination',
      'constructionList',
    ]),
    ...mapGetters({
      tipoList: 'constructionModule/getComboBoxTipoList',
      statusList: 'constructionModule/getComboBoxStatusList',
    }),

    translatedOptions() {
      return this.options.map((element) => {
        if (this.$te(`labels.${element.value}`))
          element.label = this.$t(`labels.${element.value}`)
        return element
      })
    },
  },
  methods: {
    ...mapActions('constructionModule', [
      'getConstructions',
      'getComponents',
      'deleteConstruction',
    ]),
    estiloLinha(value) {
      let dataAgora = formatDateToTimestamps(getTodayDateTimeLocal())

      if (value.QTD_FATURAS && value.QTD_FATURAS > 0) {
        return this.estiloLinhaFaturada
      } else if (
        value.PREVISAOCONCLUSAO &&
        dataAgora.substr(0, 10) > value.PREVISAOCONCLUSAO.substr(0, 10)
      ) {
        return this.estiloLinhaObraAtrasada
      } else return 'font-weight-regular'
    },
    async fetch() {
      try {
        await this.getComponents()
        await this.getConstructions(this.query)
        this.searchFields.option = this.options[0]
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async doDelete(item) {
      try {
        const response = await this.deleteConstruction(item.CODIGO)
        this.$toasted.success(response)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    changeValue(item) {
      if (item) this.textLabel = item.label
      else {
        this.textLabel = this.translatedOptions[0].label
        this.searchFields.option = this.translatedOptions[0]
      }
      this.searchFields.text = ''
    },

    openRegister() {
      this.$router.push({ name: 'obra.register' })
    },

    async sendSearch() {
      try {
        let searchText = this.searchFields.text ?? ''

        if (this.searchFields.option) {
          let key = this.searchFields.option.value

          if (searchText.trim().length > 0 && key) {
            this.query[key] = searchText
          }
        }

        if (this.searchFields.constructionStatus)
          this.query.status = this.searchFields.constructionStatus

        if (this.searchFields.useDate) {
          this.query.useDate = this.searchFields.useDate
          this.query.dataInicial = this.searchFields.dataIni
          this.query.dataFinal = this.searchFields.dataFim
        }

        await this.getConstructions(this.query)
        this.cleanSearch()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    cleanSearch() {
      Object.keys(this.query).forEach((key) => {
        if (key !== 'page' && key !== 'todos') this.query[key] = ''
      })
    },
  },
  async created() {
    await this.fetch()
    this.mountHeader()
  },
}
</script>

<style lang="css" scoped>
.customClass >>> label {
  font-size: 0.8em;
}
</style>
<style>
input::-webkit-datetime-edit {
  min-width: 100%;
  width: 100%;
}
</style>
